export default ["all", "jokes", "images"]